import { getLandingDomains } from 'api'
import { ROUTE_WHITE_LIST } from 'constant/routers'
import { addListener, launch } from 'devtools-detector'

export function load(): void {
  console.log = () => {}
  console.warn = () => {}
  console.error = () => {}
  const clear = console.clear.bind(console)

  const dropProps = (o: object): void => {
    for (const k of Object.keys(o)) {
      delete (o as Record<string, unknown>)[k]
    }
  }

  function killPage(): void {
    // 清空畫面
    document.querySelector(':root')!.remove()
    const placeholder = document.createElement('div')

    const shadow = placeholder.attachShadow({ mode: 'closed' })
    const text = document.createElement('div')
    text.textContent = 'Hey yay!'
    shadow.appendChild(text)

    function blocker(): void {
      // 洗掉 call stack 讓 devtool 更難找到觸發位置
      const fillStack = (cb: () => unknown, count = 2000): Promise<unknown> => {
        if (count > 1000) {
          return Promise.resolve().then(() => fillStack(cb, count - 1))
        } else if (count > 0) {
          return fillStack(cb, count - 1)
        } else {
          return cb() as Promise<unknown>
        }
      }
      requestAnimationFrame(async function d() {
        fillStack(() => {
          debugger
          requestAnimationFrame(d)
        })
      })
    }
    // 讓 call stack 起點變成不是在原本的代碼內
    const consoleKiller = document.createElement('iframe')
    consoleKiller.srcdoc = `
      <script>
        (${blocker.toString()})()
      </script>
    `
    placeholder.appendChild(consoleKiller)
    document.appendChild(placeholder)
    // 更多的惡作劇，故意清空 prototype 上的東西讓 devtool 裡拿不到 element 的 method
    dropProps(Node.prototype)
    dropProps(Element.prototype)
    dropProps(HTMLElement.prototype)
    dropProps(HTMLIFrameElement.prototype)
  }

  let triggered = false
  addListener((isOpen: boolean) => {
    if (isOpen && !triggered) {
      killPage()
      triggered = true
    }
  })

  const loadDevBlocker = (): void => {
    setInterval(() => {
      clear()
    }, 100)

    launch()
  }

  loadDevBlocker()

  // pwa 檢查
  const isIPhone = navigator.userAgent.toLowerCase().indexOf('iphone') >= 0
  const iOSIsInstalled = window.navigator.standalone === true
  const isInstalledPassed = iOSIsInstalled
  // 檢查白名單路由，給瀏覽器影片頁
  if (isInWhiteListRoute()) {
    return
  }

  if (!isIPhone || !isInstalledPassed) {
    toLandingPage((isIPhone ? '进行' : '') + (iOSIsInstalled ? '网页' : '') + '重新导向中...')
    throw new Error('stop loading')
  }
}

export async function toLandingPage(message: string): Promise<void> {
  try {
    const body = document.createElement('body')
    body.style.background = 'black'
    body.style.color = 'white'
    body.style.height = '100vh'
    body.textContent = message
    document.querySelector('html')!.replaceChild(body, document.querySelector('body')!)
  } catch (err) {}
  async function redirect(): Promise<void> {
    const res = await getLandingDomains()
    const links = res?.data?.map((i: { domain_name: string }) => i.domain_name) ?? []
    const selected = links[~~(Math.random() * links.length)]
    setTimeout(() => {
      window.location.replace(selected)
    }, 500)
  }
  await redirect()
}

export function isInWhiteListRoute(): boolean {
  const currentPath = window.location && window.location.pathname ? window.location.pathname : '/'
  const normalize = (s: string): string => (s || '/').replace(/\/+$/, '') || '/'
  const isWhiteRoute = ROUTE_WHITE_LIST.some((route: string) => route === normalize(currentPath))
  return isWhiteRoute
}
